import {
  getInt32,
  getObject,
} from "@surya-digital/leo-ts-types";
import { BoUserManagementSortOrder } from "./boUserManagementSortOrder";


export namespace GetBOUsersSortOrderEnums {
  /* eslint-disable @typescript-eslint/no-shadow */
  export namespace ColumnName {
    export enum ColumnName {
      FIRST_NAME = "FIRST_NAME",
      LAST_NAME = "LAST_NAME",
      EMAIL_ADDRESS = "EMAIL_ADDRESS",
      ADDED_ON = "ADDED_ON",
    }
  
    export interface ColumnNameDTO {
      case: string;
    }
  
    export const fromDTO = (dto: ColumnNameDTO): ColumnName => {
      if (dto === undefined || dto === null) {
        throw new InvalidGetBOUsersSortOrderColumnNameError(
          `Invalid DTO ${dto} provided for ColumnName.ColumnName`
        );
      }
      switch (dto.case) {
        case "FIRST_NAME":
          return ColumnName.FIRST_NAME;
        case "LAST_NAME":
          return ColumnName.LAST_NAME;
        case "EMAIL_ADDRESS":
          return ColumnName.EMAIL_ADDRESS;
        case "ADDED_ON":
          return ColumnName.ADDED_ON;
        default:
          throw new InvalidGetBOUsersSortOrderColumnNameError(
            `Case ${dto.case} is not valid case of ColumnName.ColumnName`
          );
      }
    };
  
    export const toDTO = (columnName: ColumnName): ColumnNameDTO => {
      const enumDTO = {
        case: ColumnName[columnName],
      };
      return enumDTO;
    };
  }
  
}
export interface GetBOUsersSortOrderDTO {
  sortIndex: number;
  columnName: GetBOUsersSortOrderEnums.ColumnName.ColumnNameDTO;
  order: BoUserManagementSortOrder.BoUserManagementSortOrderDTO;
}

export class GetBOUsersSortOrder {
  readonly isGetBOUsersSortOrderGetBOUsersSortOrder: boolean = true;

  readonly sortIndex: number;
  readonly columnName: GetBOUsersSortOrderEnums.ColumnName.ColumnName;
  readonly order: BoUserManagementSortOrder.BoUserManagementSortOrder;


  constructor(
  sortIndex: number, 
  columnName: GetBOUsersSortOrderEnums.ColumnName.ColumnName, 
  order: BoUserManagementSortOrder.BoUserManagementSortOrder
  ) {
    this.sortIndex = sortIndex;
    this.columnName = columnName;
    this.order = order;
  }

  static fromDTO(dto: GetBOUsersSortOrderDTO): GetBOUsersSortOrder {
    const sortIndex = getInt32(dto, "sortIndex", InvalidGetBOUsersSortOrderSortIndexError);
    const columnName = GetBOUsersSortOrderEnums.ColumnName.fromDTO(getObject(dto, "columnName", InvalidGetBOUsersSortOrderColumnNameError));
    const order = BoUserManagementSortOrder.fromDTO(getObject(dto, "order", InvalidGetBOUsersSortOrderOrderError));
    return new GetBOUsersSortOrder(
      sortIndex,
      columnName,
      order
    );
  }

  toDTO(): GetBOUsersSortOrderDTO {
    const dto: GetBOUsersSortOrderDTO = {
        sortIndex: this.sortIndex,
        columnName: GetBOUsersSortOrderEnums.ColumnName.toDTO(this.columnName),
        order: BoUserManagementSortOrder.toDTO(this.order)
    };
    return dto;
  }
  }

GetBOUsersSortOrder.prototype.toString = function toString(): string {
  return `GetBOUsersSortOrder(sortIndex='${this.sortIndex}',columnName='${this.columnName}',order='${this.order}')`;
};

export class InvalidGetBOUsersSortOrderError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetBOUsersSortOrderError";
  }
}
export class InvalidGetBOUsersSortOrderSortIndexError extends InvalidGetBOUsersSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetBOUsersSortOrderSortIndexError";
  }
}

export class InvalidGetBOUsersSortOrderColumnNameError extends InvalidGetBOUsersSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetBOUsersSortOrderColumnNameError";
  }
}

export class InvalidGetBOUsersSortOrderColumnNameFirstNameError extends InvalidGetBOUsersSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetBOUsersSortOrderColumnNameFirstNameError";
  }
}

export class InvalidGetBOUsersSortOrderColumnNameLastNameError extends InvalidGetBOUsersSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetBOUsersSortOrderColumnNameLastNameError";
  }
}

export class InvalidGetBOUsersSortOrderColumnNameEmailAddressError extends InvalidGetBOUsersSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetBOUsersSortOrderColumnNameEmailAddressError";
  }
}

export class InvalidGetBOUsersSortOrderColumnNameAddedOnError extends InvalidGetBOUsersSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetBOUsersSortOrderColumnNameAddedOnError";
  }
}

export class InvalidGetBOUsersSortOrderOrderError extends InvalidGetBOUsersSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetBOUsersSortOrderOrderError";
  }
}
